import { switchClasses, type ThemeOptions } from '@mui/material';

export function createSwitchStyles() {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: ({ ownerState, theme }) => ({
          '&:focus-within': {
            borderRadius: `${theme.ui.focus.borderRadius}`,
            outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
            outlineOffset: `${theme.ui.focus.outlineOffset}`,
          },
          [`& .${switchClasses.switchBase}`]: {
            padding: '2px',
          },
          borderRadius: `${theme.shape.borderRadius}px`,
          height: ownerState.size === 'small' ? '20px' : '24px',
          margin:
            ownerState.size === 'small'
              ? `${theme.spacing(0.25)}`
              : `${theme.spacing(0.875)}`,
          overflow: 'visible',
          padding: `${theme.spacing(0.625)}`,
          width: ownerState.size === 'small' ? '36px' : '44px',
        }),
      },
    },
  } as ThemeOptions['components'];
}
